import { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { EntregaObraClienteChecklistCadastroForm } from "../../../schemas/entrega_obra_cliente_verificacao/entregaObraClienteChecklistCadastro";
import { DropDownFuncionario } from "../../../../../../common/components/dropdown_funcionario";

/**
 * InformacoesGeraisPanel
 */

type Props = {
  statusChecklistServico: number | null;
  lockFuncionarioInspecionado: boolean;
  lockFuncionarioReinspecao: boolean;
  hookForm: UseFormReturn<EntregaObraClienteChecklistCadastroForm>;
};

export const InformacoesGeraisPanel = ({
  statusChecklistServico,
  lockFuncionarioInspecionado,
  lockFuncionarioReinspecao,
  hookForm,
}: Props) => {


  const statusOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Em Aberto',
        style: {
          backgroundColor: '#f8cb00',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 2,
        label: 'Aguardando Reinspeção',
        style: {
          backgroundColor: '#89c4f4',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        disabled: false,
        label: 'Entregue',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
    ];
  }, [
  ]);

  return (
    <>

      <CascateList title="Informações Gerais" defaultOpen>
        <div className="w-full flex flex-col gap-2">

          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-4">
            <DefaultFormInput
              name='localVistoria'
              label='Local da Vistoria'
              readOnly={false}
              reactHookForm={hookForm}
            />
          </div>
          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="w-full">
              <DropDownFuncionario
                name='idFuncionarioInsp'
                label='Inspecionado por?'
                readOnly={lockFuncionarioInspecionado || statusChecklistServico === 1}
                reactHookForm={hookForm}
              />
            </div>
            <div className="w-[40%]">
              <FormDatePickerInput
                name='dataInspecao'
                label='Data da Inspeção'
                readOnly={lockFuncionarioInspecionado || statusChecklistServico === 1}
                reactHookForm={hookForm}
              />
            </div>
          </div>

          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="w-full">
              <DropDownFuncionario
                name='idFuncionarioReinsp'
                label='Reinspecionado por?'
                required={false}
                readOnly={lockFuncionarioReinspecao || statusChecklistServico === 1}
                reactHookForm={hookForm}
              />
            </div>
            <div className="w-[40%]">
              <FormDatePickerInput
                name='dataReinsp'
                label='Data da Reinspeção'
                readOnly={lockFuncionarioReinspecao || statusChecklistServico === 1}
                reactHookForm={hookForm}
              />
            </div>

          </div>

          <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-4 items-center">
            <div className="lg:col-span-2">
              <FormRadioGroupInput
                name='status'
                label='Status'
                readOnly={false}
                options={statusOptions}
                reactHookForm={hookForm}
              />
            </div>
          </div>
        </div>
      </CascateList>
    </>

  );
}